var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('img',{class:{ spinner: true, small: _vm.small },attrs:{"src":_vm.image,"alt":"Loading"}}),(_vm.message)?_c('div',{staticClass:"message"},[_vm._v("\n\t\t"+_vm._s(_vm.message)+"\n\t")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }